import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Benefits from "@/components/Benefits";
import Package from "@/components/Package";
import ForWhom from "@/components/ForWhom";
import Differentials from "@/components/Differentials";
import HowItWorks from "@/components/HowItWorks";
import FAQ from "@/components/FAQ";
import Checkout from "@/components/Checkout";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";

const Index = () => {
  useEffect(() => {
    Sentry.setTag('ab_variant', 'A');
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: 'Page view: Variant A',
      level: 'info',
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Benefits />
        <Package />
        <ForWhom />
        <Differentials />
        <HowItWorks />
        <FAQ />
        <Checkout />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};

export default Index;
